import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { dbErrorEntry } from '../../../shared/entities/dbErrorEntry';



const ADD_ERROR_TO_DB_LOG_TABLE = 'Utility/AddErrorToDB';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable()
  export class ApnUtilitiesService {
    
    readonly restServerEndPoint: string;

    constructor(private http: HttpClient,) {
        this.restServerEndPoint = environment.RestServer;  
    }

    logErrorToDB(errorLogMessage: dbErrorEntry): any{

      const headers = {  };
      let rowsInserted: number = 0;


      try
      {

      var endpoint = this.restServerEndPoint +  ADD_ERROR_TO_DB_LOG_TABLE;

      
      
      this.http.post<any>(endpoint, errorLogMessage, { headers }).subscribe(
        data =>{
          rowsInserted = data;
        }
      );

      }
      catch(err){
        console.error(JSON.stringify(err));
      }
     
      
    }
  
    
  }